import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import SocketContext from './Context/SocketContext';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <SocketContext>
        <App />
        </SocketContext>
    </React.StrictMode>
    
);

